<div class="max-w-6xl mx-auto px-4">
  <mobo-coupon-list
    [listTitle]="category?.Name || 'Categoria não encontrada'"
    [campaigns]="campaigns"
    [showButton]="false"
  >
    <ng-container icon *ngIf="category && category.IconPath">
      <img
        width="24"
        height="24"
        [ngSrc]="category.IconPath"
        [alt]="category.Name"
        priority
      />
    </ng-container>
  </mobo-coupon-list>
</div>
